module.exports = __webpack_public_path__ + "img/belgium-blood-diseases-female.ace1098f.png";